import React from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { FORM_LAYOUT_CONFIG_USER_LEVEL_UPDATE, validationSchemaUserLevelUpdate } from '../utils/formConfig';
import useContent from '../utils/useContent';
import { IUpdateUserLevelProps } from '../types';
import { useFormConfig } from './useFormConfig';

const Content = (props: IUpdateUserLevelProps) => {
	const { handleForceUpdate = _noop, currentUserLevel } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleUpdateUserLevelFormSubmit, handleUpdateUserLevelFormCancel } = useContent({
		handleForceUpdate
	});
	const { FORM_FIELD_CONFIG_USER_LEVEL_UPDATE } = useFormConfig(currentUserLevel);

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleUpdateUserLevelFormSubmit}
				handleFormCancel={handleUpdateUserLevelFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG_USER_LEVEL_UPDATE}
				layoutConfig={FORM_LAYOUT_CONFIG_USER_LEVEL_UPDATE}
				validationSchema={validationSchemaUserLevelUpdate}
				buttonLabels={{
					submitLabel: 'Update',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
